const captchaKey = "6LdBcT4hAAAAAM89X9l8pMISsijwduF1lIoNqhAo";
export default captchaKey;
